import { Skeleton } from '@gravity-ui/uikit';

import styles from '../styles.module.scss';

export const Loader = () => {
	return (
		<div className={`${styles.info} ${styles.skeleton}`}>
			<Skeleton className={styles.info__title} style={{ width: '252px', height: '24px' }} />

			<div className={styles.info__row}>
				<Skeleton style={{ width: '186px', height: '44px' }} />
				<Skeleton style={{ width: '585px', height: '44px' }} />
			</div>
			<div className={styles.info__row}>
				<Skeleton style={{ width: '187px', height: '44px' }} />
				<Skeleton style={{ width: '585px', height: '44px' }} />
			</div>
			<div className={styles.info__row}>
				<Skeleton style={{ width: '187px', height: '44px' }} />
				<Skeleton style={{ width: '585px', height: '44px' }} />
			</div>
			<div className={styles.info__row}>
				<Skeleton style={{ width: '187px', height: '44px' }} />
				<Skeleton style={{ width: '585px', height: '44px' }} />
			</div>
			<div className={styles.info__row}>
				<Skeleton style={{ width: '187px', height: '44px' }} />
				<Skeleton style={{ width: '585px', height: '44px' }} />
			</div>
			<div className={styles.info__row}>
				<Skeleton style={{ width: '187px', height: '44px' }} />
				<Skeleton style={{ width: '585px', height: '44px' }} />
			</div>
			<div className={`${styles.info__row} ${styles.top}`}>
				<Skeleton style={{ width: '187px', height: '44px' }} />
				<Skeleton style={{ width: '585px', height: '108px' }} />
			</div>

			<div style={{ alignSelf: 'flex-end' }}>
				<Skeleton style={{ width: '152px', height: '44px', alignSelf: 'flex-end' }} />
			</div>
		</div>
	);
};
